<div class="salutation-card-row" [class.active]="active" [class.default]="disabled" fxLayout="row" (click)="toggle()">
    <div fxFlex="30px" class="left">
        <mat-icon *ngIf="active">check_box</mat-icon>
        <mat-icon *ngIf="!active">check_box_outline_blank</mat-icon>
    </div>
    <div fxFlex="calc(100% - 50px)" class="right">
        {{ name }}
    </div>
</div>
